// DateField.tsx
import React from 'react'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import esLocale from 'date-fns/locale/es'
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import './DateField.scss'

// // Azul Bootstrap, grises bootstrap
// const primaryBlue = '#0d6efd';
// const textDark = '#212529';
// const textMuted = '#6c757d';

// const localTheme = createMuiTheme({
//   palette: {
//     primary: { main: primaryBlue },
//     text: { primary: textDark, secondary: textMuted },
//   },
//   overrides: {
//     // barra superior del diálogo (header morado)
//     MuiPickersToolbar: {
//       toolbar: { backgroundColor: primaryBlue },
//     },
//     // etiqueta de días de la semana
//     MuiPickersCalendarHeader: {
//       dayLabel: { color: textMuted },
//     },
//     // día seleccionado y "hoy"
//     MuiPickersDay: {
//       daySelected: { backgroundColor: primaryBlue },
//       current: { color: primaryBlue },
//     },
//     // borde del input outlined
//     MuiOutlinedInput: {
//       notchedOutline: { borderColor: '#ced4da' },
//     },
//     // icono del botón (que no quede blanco)
//     MuiIconButton: {
//       root: { color: textDark },
//     },
//   },
// });

// type Props = {
//   label?: string;
//   value: Date | null;
//   onChange: (d: Date | null) => void;
//   minDate?: Date;
//   maxDate?: Date;
//   disabled?: boolean;
//   required?: boolean;
// };

export default function DateField({
  name,
  value,
  onChange,
  minDate,
  maxDate,
  disabled,
  required,
}) {
  // Convertir string a Date si es necesario
  const parseValue = (val) => {
    if (!val) return null
    if (val instanceof Date) return val
    if (typeof val === 'string') {
      // Si es formato YYYY-MM-DD, convertir a Date
      if (/^\d{4}-\d{2}-\d{2}$/.test(val)) {
        return new Date(val + 'T00:00:00')
      }
      // Intentar parsear otros formatos
      const parsed = new Date(val)
      return isNaN(parsed.getTime()) ? null : parsed
    }
    return null
  }

  const handleDateChange = (date) => {
    if (!onChange) return

    // Crear evento sintético para compatibilidad
    // Usar métodos locales para evitar problemas de zona horaria
    const formattedDate = date
      ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
          2,
          '0',
        )}-${String(date.getDate()).padStart(2, '0')}`
      : ''
    const syntheticEvent = {
      target: {
        name: name,
        value: formattedDate,
      },
    }
    onChange(syntheticEvent)
  }

  return (
    // <ThemeProvider theme={localTheme}>
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
      <KeyboardDatePicker
        autoOk
        variant='inline' // popover integrado (o "dialog" si prefieres modal)
        inputVariant='outlined'
        format='dd/MM/yyyy'
        // label={label}
        value={parseValue(value)}
        onChange={handleDateChange}
        minDate={minDate}
        maxDate={maxDate}
        disabled={disabled}
        required={required}
        placeholder='dd/mm/aaaa'
        disableToolbar // <- quita el reloj/hora
        ampm={false} // por si acaso
        // para que encaje visualmente con Bootstrap
        fullWidth
        InputProps={{ className: 'form-control' }}
        KeyboardButtonProps={{ 'aria-label': 'cambiar fecha' }}
        invalidDateMessage='Formato de fecha inválido'
        minDateMessage='La fecha no puede ser anterior a la fecha mínima'
        maxDateMessage='La fecha no puede ser posterior a la fecha máxima'
      />
    </MuiPickersUtilsProvider>
    // </ThemeProvider>
  )
}
